import type { MutableEmptyObject } from '@enmon/commons';
import { Card } from 'components';
import type { FC } from 'react';

interface MeterModulePhotosProps extends MutableEmptyObject {}

export const MeterModulePhotos: FC<MeterModulePhotosProps> = () => {
  return <Card title="Photos"> </Card>;
};
